<template>
    <section>
        <h1>{{ $t("شروط استخدام الخدمة") }}</h1>
        <div class="content">
            <div class="side">
                <article>
                    <h4>كيف تعمل بريديكس؟</h4>
                    <p>{{ $t("Term 1") }}</p>
                </article>
                <article>
                    <h4>مسؤولية محتوى الشحنة</h4>
                    <p>{{ $t("Term 2") }}</p>
                </article>
                <article>
                    <h4>بنود الوزن الزائد الغير مصرح به</h4>
                    <p>{{ $t("Term 3") }}</p>
                </article>
            </div>
            <div class="side">
                <article>
                    <h4>الإفصاح الجمركي</h4>
                    <p>
                        {{
                            $t(
                                "Please make sure to use HEAVY DUTY boxes to protect your shipment. If you are shipping from the United States, you can buy your boxes through"
                            )
                        }}
                    </p>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
section {
    padding-top: 40px;
    background: #f2f2f2;
    min-height: 100vh;

    h1 {
        text-align: center;
        font-size: 60px;
        font-weight: bold;
    }

    .content {
        display: flex;
        justify-content: space-between;

        .side {
            width: 50%;
            padding: 60px;

            article {
                margin: 30px 0;
            }
        }
    }
}
</style>
